import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import styles from "./NotFoundPage.module.css";
import { Card, CardBody } from "../design/Card.js";
import { usePageChrome } from "../design/pageChrome.js";

export function NotFoundPage(): ReactNode {
  // Without this the shell would fall back to a title keyed on the pathname,
  // and a mistyped /deals/xyz would announce itself as "Deal".
  usePageChrome({ title: "Page not found" });

  return (
    <div className={styles.page}>
      <Card>
        <CardBody>
          <h2 className={styles.title}>That page doesn't exist</h2>
          {/* Points at the sidebar rather than listing the screens: the list
              grew by two the last time it was written down here. */}
          <p className={styles.body}>Every screen the CRM has is in the sidebar.</p>
          <p className={styles.body}>
            If you followed a link to a specific deal or partner, the record may have been removed.
          </p>
          <Link to="/" className={styles.back}>
            Back to the dashboard
          </Link>
        </CardBody>
      </Card>
    </div>
  );
}
